import React from "react";
import { ChevronRight } from "@yleisradio/yds-icons-react";
import styled from "styled-components";

import { UI_SIZE } from "../../enums";
import { upperCaseFirstLetter } from "../../helpers/commonUtils";
import { usePlayerStore } from "../../store/usePlayerStore";
import { focusColor } from "../../styles/variables";
import { Button, SettingHeader } from "../settings/styles";

const TopLevelSettingsOptionValue = styled.div`
  @media (width <= 290px) {
    display: none;
  }
`;

const TopLevelSettingOptionButton = styled(Button)`
  align-items: center;
  align-self: stretch;
  display: flex;
  flex-direction: row;
  flex-grow: 0;
  justify-content: space-between;

  &:focus-visible {
    outline: 1px solid ${focusColor} !important;
  }
`;

const TopLevelSettingOptionValue = styled.span<{ uiSize?: UI_SIZE }>`
  font-size: ${({ uiSize }) => (uiSize === UI_SIZE.LARGE ? "14px" : "12px")};
  font-weight: normal;

  svg {
    margin-left: 8px;
  }
`;

type OptionProps = {
  autoFocus?: boolean;
  onClick: () => void;
  title: string;
  value?: string;
};

export const TopLevelSettingOption = ({
  autoFocus = false,
  onClick,
  title,
  value
}: OptionProps) => {
  const { useStoreState } = usePlayerStore();
  const uiSize = useStoreState.uiSize();

  return (
    <TopLevelSettingOptionButton autoFocus={autoFocus} onClick={onClick}>
      <SettingHeader uiSize={uiSize}>{title}</SettingHeader>
      <TopLevelSettingOptionValue uiSize={uiSize}>
        <TopLevelSettingsOptionValue>
          {upperCaseFirstLetter(value)}
        </TopLevelSettingsOptionValue>
        <ChevronRight />
      </TopLevelSettingOptionValue>
    </TopLevelSettingOptionButton>
  );
};
